module.exports = __webpack_public_path__ + "static/media/pic2_kethmi.34b45c70.avif";